import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import PrivateRoute from '../routing/PrivateRoute';
import Login from '../auth/Login';
import Logout from '../auth/Logout';
import LoginUtente from '../auth/LoginUtente';
import RecuperaPassword from '../auth/RecuperaPassword';
import NuovaPassword from '../auth/NuovaPassword';
import NotFound from '../layout/NotFound';
import GestionePortale from '../admin/GestionePortale';
import ArchivioEventi from '../admin/ArchivioEventi';
import AggiungiEvento from '../admin/AggiungiEvento';
import ModificaEvento from '../admin/ModificaEvento';
import Agenda from '../utente/Agenda';
import EventoAgenda from '../utente/EventoAgenda';
import EventoAgendaStatistiche from '../admin/EventoAgendaStatistiche';
import AggiungiUtente from '../auth/AggiungiUtente';
import ModificaProfilo from '../auth/ModificaProfilo';
import ModificaUtente from '../auth/ModificaUtente';
import GestioneUtenti from '../auth/GestioneUtenti';
import Changelog from '../changelog/Changelog';
import Footer from '../layout/Footer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GestioneAudio from '../audio/GestioneAudio';
import AggiungiAudio from '../audio/AggiungiAudio';
import ModificaAudio from '../audio/ModificaAudio';
import ListaUtenti from '../admin/ListaUtenti';



const Routes = ({auth: { user, isAuthenticated }}) => {
    return (
      <BrowserRouter>
        <Switch>
        <Route exact path="/login" component={LoginUtente} />
        <PrivateRoute exact path="/" component={Agenda} />

        <Route exact path="/admin" component={Login} />
        <PrivateRoute exact path="/gestione-portale" component={GestionePortale} />
        <PrivateRoute exact path="/archivio-eventi" component={ArchivioEventi} />
        <PrivateRoute exact path="/aggiungi-evento" component={AggiungiEvento} />
        <PrivateRoute path="/evento/:roomName/:roomKey" component={EventoAgenda} />
        <PrivateRoute path="/statistiche-evento/:idEvento" component={EventoAgendaStatistiche} />
        <PrivateRoute path="/modifica-evento/:idEvento" component={ModificaEvento} />

        <PrivateRoute exact path="/gestione-audio" component={GestioneAudio} />
        <PrivateRoute exact path="/aggiungi-audio" component={AggiungiAudio} />
        <PrivateRoute path="/modifica-audio/:idAudio" component={ModificaAudio} />
        <PrivateRoute exact path="/lista-utenti" component={ListaUtenti} />

        <Route exact path="/logout" component={Logout} />

        <Route exact path="/recupero-password" component={RecuperaPassword}/>
        <Route exact path="/nuova-password/:token" component={NuovaPassword} />
        <PrivateRoute exact path="/modifica-profilo" component={ModificaProfilo} />
        <PrivateRoute exact path="/gestione-utenti" component={GestioneUtenti} />
        <PrivateRoute exact path="/aggiungi-utente" component={AggiungiUtente} />
        <PrivateRoute path="/modifica-utente/:idUtente" component={ModificaUtente} />
        
        <PrivateRoute exact path="/changelog" component={Changelog} />
        <Route component={NotFound} />
        </Switch>
        <Footer />
      </BrowserRouter>
    )
}

Routes.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(Routes);

